/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Nivel 3: Calcular estadísticas de videos seleccionados.
 */
export interface StatsAiStatsRequest { 
    team_id: string;
    video_ids: Array<string>;
    play_type?: string | null;
    defense_type?: string | null;
    attack_type?: string | null;
    throw_type?: string | null;
    action_zone?: string | null;
    modelo_juego?: string | null;
    numeric_situation?: string | null;
    opponent_team_id?: string | null;
}

